



<!----------New html of account manager listing-------------->
<div>
  <div class="breadcrumb_outer">
    <ul class="breadcrumb">
      <li class="active"><a>Account Manager</a></li>
    </ul>
    <!-- <div class="right"><span>{{today}}</span></div> -->
  </div>
  <div class="tag_powered_by">
    <span>Powered by: <b>Enertics</b></span>
  </div>
  <div class="Content_outer">
      <div class="content_view">
          <div class="row">
            <div class="col-md-12">
                <div class="listing_outer acc_manager">
                      <div class="filter_div">
                          <div class="top">
                              <h4>Account Manager Clients</h4>
                              <div class="right">
                               <div class="custom_search width_250">
                                  <span class="sprite_icon search"></span>
                                  <input type="text" class="form-control" placeholder="Search: Client, Industry or Country"
                                  (input)="searchData($event.target.value)">
                                </div>
                                <!-- <button class="primary_btn" mat-raised-button  (click)="addClients()">
                                  <span class="sprite_icon plus_white"></span>
                                  <span>Add Account Manager</span>
                                </button> -->
                              </div>
                          </div>
                      </div>

                      <div class="no_result" *ngIf="emptyMsg">
                        No clients available
                      </div>

                      <div class="listing_box" *ngFor="let clients of allClients;trackBy: trackByFn;let idx = index;">
                            <div class="left">
                                 <div class="img_outer">
                                     <img src="{{clients.profile_image}}" alt="Manager" onerror="this.src='assets/img-new/client.png';">
                                 </div>
                                 <div class="details">
                                    <h4>{{clients.company_name}}</h4>
                                    <h6><span><img src="./assets/img-new/ind_flag.png" alt="India" class="m_r_5"></span>{{clients.country}}, {{clients.state}}</h6>
                                 </div>
                            </div>
                            <div class="actions dropdown">
                                <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                                  <span class="sprite_icon ellipse_black"></span>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <div class="client_action">
                                    <a class="dropdown-item" (click)="seeUserAssets(clients.id, clients.company_name)">View</a>
                                    <!-- <a class="dropdown-item" (click)="showDeleteDialog(clients.id, idx)">Delete</a> -->
                                  </div>
                                </mat-menu>
                            </div>
                      </div>
                </div>
            </div>
          </div>
      </div>
  </div>
</div>
<!-- ---------------- -->